<template>
  <div class="hello">
    <!-- style="position: absolute;" -->
    <header class="frame-header" >
      <div style="display: flex; align-items: center;">
        <img src="../../static/img/logo.png" alt="logo" class="logo" />
        <!-- <img src="/static/img/name.png" alt="导航入口" class="enter" style="margin-left: 5px; width: 84px;"> -->
        <span class="titlep">管理中学，就用凡高</span>
      </div>

      <div style="display: flex; justify-content: space-between; align-items: center;">
        <router-link to="/applyfortrial">
          <div class="button">申请试用</div>
        </router-link>
        <img
          src="../../static/img/more.png"
          alt="导航入口"
          :class="{enter:true , 'enter-rotate':show}"
          @click="showNav"
        />
      </div>
    </header>

    <div :class="{'nav-select':true , 'select-transition-show':show}">
      <ul>
        <li :class="{'router-link-exact-active':active == 1 }" @click="link('index',1)">首页</li>
        <li
          :class="{'router-link-exact-active':active == 2 }"
          @click="link('classselection',2)"
        >校园管理平台</li>
        <li :class="{'router-link-exact-active':active == 3 }" @click="link('campuspaymen',3)">招生缴费系统</li>
        <li :class="{'router-link-exact-active':active == 4 }" @click="link('classcard',4)">校园一脸通</li>
        <li :class="{'router-link-exact-active':active == 5 }" @click="link('homeschool',5)">智慧校园AIOT硬件</li>
        <li
          :class="{'router-link-exact-active':active == 6 }"
          @click="link('smarteducational',6)"
        >服务</li>
        <li
          :class="{'router-link-exact-active':active == 7 }"
          @click="link('companyprofile',7)"
        >案例</li>
        <li
          :class="{'router-link-exact-active':active == 8 }"
          @click="link('businesscooperation',8)"
        >关于凡高</li>
      </ul>
      <div class="zixun">咨询热线：</div>
      <div style="margin-left: 6%; margin-top: 15px;">
          <a href="tel:19930383437" class="tel" style="color: #2AB1F3;">19930383437/刘经理</a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import d3 from "./campuspayment.vue";
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "",
      data: "",
      show: false,
      active: "1"
    };
  },
  components: {},
  mounted() {
    this.active = localStorage.active;
  },
  methods: {
    showNav() {
      if (this.show) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    link(name, n) {
      localStorage.active = n;
      this.$router.push({ name: name, params: {} });
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hiddenWrap {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.frame-header .enter.enter-rotate {
  transform: rotate(90deg);
}
.frame-header {
  width: 100%;
  height: 120px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-align: center;
  align-items: center;
  z-index: 99;
  position: fixed;
  /* position: absolute; */
  top: 0;

  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 8px 0px rgba(238, 238, 238, 1);
}
.frame-header .logo {
  /* height: 32px; */
  margin-left: 40px;
  width: 53px;
  height: 50px;
  margin-right: 10px;
}
.titlep {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}
.frame-header .button {
  text-align: center;
  line-height: 54px;
  width: 160px;
  height: 54px;
  background: rgba(42, 177, 243, 1);
  border-radius: 8px;

  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.frame-header .enter {
  transition: all 0.3s;
  transform: rotate(0);
  height: 30px;
  margin: 0 27px;
}

.nav-select.select-transition-show {
  transform: translateY(60px);
}

.nav-select {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 55px;
  background: #fff;
  transition: all 0.3s;
  transform: translateY(-100%);
  z-index: 98;
  overflow: hidden;
  overflow-y: auto;
  text-align: left;
}

.nav-select > ul {
  padding: 0 6%;
}

.nav-select > ul > li {
  height: 100px;
  line-height: 100px;
  border-bottom: 1px solid #dedede;
  text-align: left;

  font-size: 36px;
  font-family: PingFang SC;
  font-weight: 400;
}
.router-link-exact-active {
  color: #2ab1f3;
}
.hiddenWrap {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.zixun {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  margin-left: 6%;
  margin-top: 28px;
}
.tel {
  font-size: 36px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(42, 177, 243, 1);
  /* line-height:21px; */
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue